import { render, staticRenderFns } from "./StudipSquareButton.vue?vue&type=template&id=00404b52&scoped=true&"
import script from "./StudipSquareButton.vue?vue&type=script&lang=js&"
export * from "./StudipSquareButton.vue?vue&type=script&lang=js&"
import style0 from "./StudipSquareButton.vue?vue&type=style&index=0&id=00404b52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00404b52",
  null
  
)

export default component.exports